import { createRequestInstance } from 'services'
import { FetchSubscriptionResponse } from 'services/programming'

const VITE_SUBSCRIPTIONS_API_URL = import.meta.env.VITE_SUBSCRIPTIONS_API_URL
const request = createRequestInstance({
  baseURL: VITE_SUBSCRIPTIONS_API_URL,
})

export async function fetchMySubscriptions() {
  const response = await request.get<FetchSubscriptionResponse>(
    'subscriptions/me',
    {
      params: {
        detail: 'full',
        include_inactive: true,
      },
    },
  )

  return response.data
}
